export default {
  salesDecomposition: '{kpi} Decomposition',
  dataView: 'Data View',
  close: 'Close',
  refresh: 'Refresh',
  saveAsImage: 'Save as Image',
  base: 'Base',
  carryOverMarketing: 'Carry-over Marketing',
  instantMarketing: 'Instant Marketing',
  noise: 'Noise',
  seasonality: 'Seasonality',
  external: 'External',
  total: 'Total'
}
